module.exports = __webpack_public_path__ + "img/rules.495222c5.jpg";